import React from 'react'
import DashboardComponent from '../components/DashboardComponent'


function Dashboard() {
    return (<DashboardComponent />)
}

export default Dashboard
